import { render, staticRenderFns } from "./Pokemon.vue?vue&type=template&id=2f6e3d1b&scoped=true&"
import script from "./Pokemon.vue?vue&type=script&lang=js&"
export * from "./Pokemon.vue?vue&type=script&lang=js&"
import style0 from "./Pokemon.vue?vue&type=style&index=0&id=2f6e3d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e3d1b",
  null
  
)

export default component.exports